import { PatternsTheme } from "../.internal/themes/PatternsTheme";
export default PatternsTheme;
